document.addEventListener('DOMContentLoaded', function () {
    console.log("📸📸📸📸📸📸");
    console.log("[Order Status Popup] init");
  
    // Only run on /pages/order-status
    var pathname = window.location.pathname || '';
    console.log("[Order Status Popup] Current pathname:", pathname);
  
    if (!pathname.includes('/pages/order-status')) {
      console.log("[Order Status Popup] Not order-status page, aborting.");
      return;
    }
    console.log("[Order Status Popup] Page path condition PASSED.");
  
    var params = new URLSearchParams(window.location.search);
    var tokenId = params.get('tokenId');
    console.log("[Order Status Popup] tokenId from URL:", tokenId);
  
    if (!tokenId) {
      console.warn('[Order Status Popup] No tokenId in URL. Aborting popup logic.');
      return;
    }
  
    // Optional: Add tokenId validation here if needed for testing
    // if (tokenId != "your-test-token-id") {
    //   console.warn('[Order Status Popup] tokenId mismatch. Aborting popup logic.');
    //   return;
    // }
  
    // Force main content visible
    const mainEle = document.getElementById("MainContent");
    const mainSectionsEle = document.querySelectorAll('main .shopify-section');
  
    if (mainEle) {
      mainEle.style.setProperty('display', 'block', 'important');
    }
    mainSectionsEle.forEach(section => {
      section.style.setProperty('display', 'block', 'important');
    });
  
    // Force Shopflo elements z-index
    const observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        mutation.addedNodes.forEach(node => {
          if (!(node instanceof HTMLElement)) return;
  
          if (node.classList?.contains('flo-order-status-wrapper')) {
            node.style.setProperty('z-index', '999999', 'important');
          }
  
          if (node.classList?.contains('flo-order-status-main')) {
            node.style.setProperty('z-index', '999999', 'important');
          }
  
          node.querySelectorAll?.('.flo-order-status-wrapper, .flo-order-status-main')
            .forEach(el => {
              el.style.setProperty('z-index', '999999', 'important');
            });
        });
      });
    });
  
    observer.observe(document.body, { childList: true, subtree: true });
  
    // === Config: Variant IDs that trigger the popup ===
    // Add variant IDs for paid trial purchase and scale variants here
    var ELIGIBLE_VARIANT_IDS = [
      50564293132578,
      50792440529186
    ];
      // 2 Week Trial Diet Plan (Paid Trial Purchase)
      // Add scale variant IDs below:
      // 49542323405090, // Example: Scale Variant 1
      // 12345678901234, // Example: Scale Variant 2
  
    // === Helpers ===
    function formatDateValue(dateObj) {
      var y = dateObj.getFullYear();
      var m = ('0' + (dateObj.getMonth() + 1)).slice(-2);
      var d = ('0' + dateObj.getDate()).slice(-2);
      return y + '-' + m + '-' + d;
    }
  
    function formatDateLabel(dateObj) {
      var days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
      var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      return days[dateObj.getDay()] + ', ' + dateObj.getDate() + ' ' + months[dateObj.getMonth()];
    }
  
    /**
     * Fetch available slots from backend
     */
    function fetchAvailableSlots() {
      // Update this URL with your actual backend API endpoint
      var slotsApiUrl = 'https://shop-store.production.fitelo.net/consultation-slots';
      return fetch(slotsApiUrl)
        .then(res => {
          if (!res.ok) {
            throw new Error('Failed to fetch available slots');
          }
          return res.json();
        })
        .then(data => {
          if (data.success && data.data) {
            return data.data;
          }
          throw new Error('Invalid slots response format');
        });
    }
  
    // === Popup creation ===
    var overlay = document.getElementById('order-status-popup-overlay');
  
    function closePopup() {
      if (overlay) {
        overlay.classList.remove('is-visible');
        overlay.setAttribute('aria-hidden', 'true');
      }
    }
  
    function buildPopup(order, tokenId) {
      if (!overlay) {
        console.error("[Order Status Popup] buildPopup aborted - overlay element not found.");
        return;
      }
  
      var storageKey = 'fitelo_order_status_popup_shown_' + order.id;
      var alreadyShown = window.localStorage && localStorage.getItem(storageKey) === '1';
      if (alreadyShown) {
        console.log("[Order Status Popup] Popup already shown for this order.");
        return;
      }
  
      var languages = ['Hindi', 'English', 'Telugu', 'Tamil', 'Malayalam', 'Kannada'];
  
      overlay.innerHTML = '';
      var container = document.createElement('div');
      container.className = 'order-status-popup';
      container.innerHTML = `
        <div class="order-status-popup-header">
          <h3 class="order-status-popup-title">Start your 2-Week Trial Plan</h3>
          <button class="order-status-popup-close" type="button" aria-label="Close popup">&times;</button>
        </div>
        <div class="order-status-popup-body">
          <div class="order-status-step-1">
            <p>Do you want to start your diet plan now, or after your scale delivery?</p>
            <div class="order-status-popup-actions">
              <button type="button" class="order-status-btn order-status-btn-secondary order-status-btn-later">After delivery</button>
              <button type="button" class="order-status-btn order-status-btn-primary order-status-btn-start">Start now</button>
            </div>
          </div>
  
          <div class="order-status-step-2" style="display:none;">
            <p>Please pick your preferred slot for the first consultation.</p>
            <form class="order-status-form">
              <div class="order-status-form-group">
                <label for="order-status-date">Choose a date</label>
                <select id="order-status-date" required>
                  <option value="">Loading dates...</option>
                </select>
              </div>
              <div class="order-status-form-group">
                <label for="order-status-time">Choose a time slot</label>
                <select id="order-status-time" required>
                  <option value="">Select date first</option>
                </select>
              </div>
              <div class="order-status-form-group">
                <label for="order-status-language">Preferred language</label>
                <select id="order-status-language" required></select>
              </div>
              <div class="order-status-popup-actions">
                <button type="button" class="order-status-btn order-status-btn-secondary order-status-btn-back">Back</button>
                <button type="submit" class="order-status-btn order-status-btn-primary">Confirm slot</button>
              </div>
            </form>
            <div class="order-status-popup-message order-status-popup-message--error" style="display:none;"></div>
            <div class="order-status-popup-message order-status-popup-message--success" style="display:none;"></div>
          </div>
        </div>
      `;
      overlay.appendChild(container);
  
      // Populate language dropdown
      var langSelect = container.querySelector('#order-status-language');
      languages.forEach(lang => {
        var optL = document.createElement('option');
        optL.value = lang;
        optL.textContent = lang;
        langSelect.appendChild(optL);
      });
  
      // Fetch and populate slots from backend
      var dateSelect = container.querySelector('#order-status-date');
      var timeSelect = container.querySelector('#order-status-time');
      var availableSlots = [];
  
      fetchAvailableSlots()
        .then(slots => {
          availableSlots = slots;
          console.log("[Order Status Popup] Fetched slots from backend:", slots);
          
          // Group slots by date
          var slotsByDate = {};
          slots.forEach(slot => {
            var dateStr = formatDateValue(new Date(slot.slotDate));
            if (!slotsByDate[dateStr]) {
              slotsByDate[dateStr] = [];
            }
            slotsByDate[dateStr].push(slot);
          });
          
          // Populate date dropdown with unique dates
          dateSelect.innerHTML = '<option value="">Select a date</option>';
          Object.keys(slotsByDate).sort().forEach(dateStr => {
            var opt = document.createElement('option');
            opt.value = dateStr;
            var dateObj = new Date(dateStr);
            opt.textContent = formatDateLabel(dateObj);
            dateSelect.appendChild(opt);
          });
          
          // Update time slots when date changes
          dateSelect.addEventListener('change', function() {
            var selectedDate = this.value;
            timeSelect.innerHTML = '<option value="">Select a time slot</option>';
            
            if (selectedDate && slotsByDate[selectedDate]) {
              slotsByDate[selectedDate].forEach(slot => {
                if (slot.availableSlots > 0) {
                  var optT = document.createElement('option');
                  optT.value = slot.slotTime;
                  optT.textContent = slot.slotTime + ' (' + slot.availableSlots + ' available)';
                  timeSelect.appendChild(optT);
                }
              });
            }
          });
        })
        .catch(err => {
          console.error('[Order Status Popup] Failed to fetch slots:', err);
          dateSelect.innerHTML = '<option value="">Error loading slots</option>';
          var errorMsgEl = container.querySelector('.order-status-popup-message--error');
          if (errorMsgEl) {
            errorMsgEl.textContent = 'Failed to load available slots. Please refresh the page.';
            errorMsgEl.style.display = 'block';
          }
        });
  
      var step1 = container.querySelector('.order-status-step-1');
      var step2 = container.querySelector('.order-status-step-2');
      var btnClose = container.querySelector('.order-status-popup-close');
      var btnLater = container.querySelector('.order-status-btn-later');
      var btnStart = container.querySelector('.order-status-btn-start');
      var btnBack = container.querySelector('.order-status-btn-back');
      var form = container.querySelector('.order-status-form');
      var errorMsg = container.querySelector('.order-status-popup-message--error');
      var successMsg = container.querySelector('.order-status-popup-message--success');
  
      function markShown() {
        if (window.localStorage) {
          // localStorage.setItem(storageKey, '1');
        }
      }
  
      btnClose.addEventListener('click', function () {
        markShown();
        closePopup();
      });
  
      btnLater.addEventListener('click', function () {
        markShown();
        closePopup();
      });
  
      btnStart.addEventListener('click', function () {
        // Extract customer data from order
        var customerName = '';
        if (order.customer) {
          var firstName = order.customer.first_name || '';
          var lastName = order.customer.last_name || '';
          customerName = (firstName + ' ' + lastName).trim();
        }
        if (!customerName && order.shipping_address) {
          customerName = order.shipping_address.name || '';
        }

        // Extract address from shipping_address
        var address = '';
        if (order.shipping_address) {
          var addr1 = order.shipping_address.address1 || '';
          var addr2 = order.shipping_address.address2 || '';
          address = (addr1 + ' ' + addr2).trim();
        }

        // Extract other fields
        var city = (order.shipping_address && order.shipping_address.city) || '';
        var state = (order.shipping_address && order.shipping_address.province) || '';
        var pincode = (order.shipping_address && order.shipping_address.zip) || '';
        var paymentMode = order.financial_status || '';
        
        // Format sale date from processed_at
        var saleDate = '';
        if (order.processed_at) {
          var processedDate = new Date(order.processed_at);
          if (!isNaN(processedDate.getTime())) {
            saleDate = formatDateValue(processedDate);
          }
        }

        var initPayload = {
          tokenId: tokenId,
          orderId: order.id ? String(order.id) : null,
          orderName: order.name || null,
          customerEmail: order.email || null,
          customerPhone: order.phone || (order.shipping_address && order.shipping_address.phone) || '',
          customerName: customerName || null,
          address: address || null,
          city: city || null,
          state: state || null,
          pincode: pincode || null,
          paymentMode: paymentMode || null,
          saleDate: saleDate || null
        };

        console.log("[Order Status Popup] Step 1: Initializing booking:", initPayload);

        // Call initialize API in background with retry
        var initializeApiUrl = 'https://shop-store.production.fitelo.net/consultation-bookings/initialize';
        var maxRetries = 3;
        var retryDelay = 1000; // Start with 1 second

        function attemptInitialize(attempt) {
          fetch(initializeApiUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(initPayload)
          })
            .then(res => {
              if (!res.ok) {
                throw new Error('Initialize API failed with status: ' + res.status);
              }
              return res.json();
            })
            .then(responseJson => {
              console.log("[Order Status Popup] Step 1 initialization successful:", responseJson);
            })
            .catch(err => {
              console.error('[Order Status Popup] Step 1 initialization failed (attempt ' + attempt + '):', err);
              
              // Retry if we haven't exceeded max attempts
              if (attempt < maxRetries) {
                var nextDelay = retryDelay * Math.pow(2, attempt - 1); // Exponential backoff
                console.log('[Order Status Popup] Retrying Step 1 in ' + nextDelay + 'ms...');
                setTimeout(function() {
                  attemptInitialize(attempt + 1);
                }, nextDelay);
              } else {
                console.error('[Order Status Popup] Step 1 initialization failed after ' + maxRetries + ' attempts');
              }
            });
        }

        // Start the initialization attempt
        attemptInitialize(1);

        // Show Step 2 immediately (don't wait for initialization)
        step1.style.display = 'none';
        step2.style.display = 'block';
      });
  
      btnBack.addEventListener('click', function () {
        step2.style.display = 'none';
        step1.style.display = 'block';
      });
  
      form.addEventListener('submit', function (e) {
        e.preventDefault();
  
        if (errorMsg) { errorMsg.style.display = 'none'; errorMsg.textContent = ''; }
        if (successMsg) { successMsg.style.display = 'none'; successMsg.textContent = ''; }
  
        var selectedDate = dateSelect.value;
        var selectedTime = timeSelect.value;
        var selectedLanguage = langSelect.value;
  
        if (!selectedDate || !selectedTime || !selectedLanguage) {
          if (errorMsg) {
            errorMsg.textContent = 'Please select date, time, and language.';
            errorMsg.style.display = 'block';
          }
          return;
        }
  
        // Extract customer name from order
        var customerName = '';
        if (order.customer) {
          var firstName = order.customer.first_name || '';
          var lastName = order.customer.last_name || '';
          customerName = (firstName + ' ' + lastName).trim();
        }
        if (!customerName && order.shipping_address) {
          customerName = order.shipping_address.name || '';
        }
  
        // Extract address from shipping_address
        var address = '';
        if (order.shipping_address) {
          var addr1 = order.shipping_address.address1 || '';
          var addr2 = order.shipping_address.address2 || '';
          address = (addr1 + ' ' + addr2).trim();
        }
  
        // Extract other fields
        var city = (order.shipping_address && order.shipping_address.city) || '';
        var state = (order.shipping_address && order.shipping_address.province) || '';
        var pincode = (order.shipping_address && order.shipping_address.zip) || '';
        var paymentMode = order.financial_status || '';
        
        // Format sale date from processed_at
        var saleDate = '';
        if (order.processed_at) {
          var processedDate = new Date(order.processed_at);
          if (!isNaN(processedDate.getTime())) {
            saleDate = formatDateValue(processedDate);
          }
        }

        var payload = {
          tokenId: tokenId,
          orderId: order.id ? String(order.id) : null,
          orderName: order.name || null,
          customerEmail: order.email || null,
          customerPhone: order.phone || (order.shipping_address && order.shipping_address.phone) || '',
          customerName: customerName || null,
          address: address || null,
          city: city || null,
          state: state || null,
          pincode: pincode || null,
          paymentMode: paymentMode || null,
          saleDate: saleDate || null,
          slotDate: selectedDate,
          slotTime: selectedTime,
          preferredLanguage: selectedLanguage,
          isStartingNow: true // Form only shows when "Start now" is clicked
        };
  
        console.log("[Order Status Popup] Submitting booking payload:", payload);
  
        // Disable form during submission
        var submitBtn = form.querySelector('button[type="submit"]');
        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.textContent = 'Booking...';
        }
  
        // --- Actual API call ---
        // Update this URL with your actual backend API endpoint
        var bookingApiUrl = 'https://shop-store.production.fitelo.net/consultation-bookings';
        fetch(bookingApiUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        })
          .then(res => {
            if (!res.ok) {
              return res.json().then(err => {
                throw new Error(err.message || 'Network response was not ok');
              });
            }
            return res.json();
          })
          .then(responseJson => {
            console.log("[Order Status Popup] Booking API success:", responseJson);
            
            // === Step 3: Beautiful Thank You Message ===
            const popupBody = container.querySelector('.order-status-popup-body');
            popupBody.innerHTML = `
              <div class="order-status-step-3 fade-in">
                <div class="order-status-thankyou-icon">🎉</div>
                <h3 class="order-status-thankyou-title">Thank You!</h3>
                <p class="order-status-thankyou-msg">
                  Your slot has been booked successfully.<br/>
                  Our dietitian will connect with you at your preferred time:
                </p>
                <p class="order-status-thankyou-details">
                  <strong>${formatDateLabel(new Date(selectedDate))}</strong><br/>
                  <strong>${selectedTime}</strong><br/>
                  <span>${selectedLanguage}</span>
                </p>
                <button type="button" class="order-status-btn order-status-btn-primary order-status-btn-close-final">
                  Close
                </button>
              </div>
            `;
            
            popupBody.querySelector('.order-status-btn-close-final').addEventListener('click', function() {
              markShown();
              closePopup();
            });
            
            markShown();
            
            // Auto close after 5s
            setTimeout(function() {
              markShown();
              closePopup();
            }, 5000);
          })
          .catch(err => {
            console.error('[Order Status Popup] Booking API error:', err);
            
            // Re-enable form
            if (submitBtn) {
              submitBtn.disabled = false;
              submitBtn.textContent = 'Confirm slot';
            }
            
            // Show error message
            if (errorMsg) {
              errorMsg.textContent = err.message || 'Failed to book slot. Please try again.';
              errorMsg.style.display = 'block';
            }
          });
      });
  
      overlay.classList.add('is-visible');
      overlay.setAttribute('aria-hidden', 'false');
    }
  
    // === Fetch Shopflo status ===
    var shopfloUrl = 'https://api.shopflo.co/public/api/v1/tokens/' + encodeURIComponent(tokenId) + '/status';
    console.log("[Order Status Popup] Fetching Shopflo status from:", shopfloUrl);
  
    fetch(shopfloUrl)
      .then(res => {
        if (!res.ok) throw new Error('Shopflo API error: ' + res.status);
        return res.json();
      })
      .then(data => {
        var resp = data.response || {};
        var status = resp.status;
        var order = resp.order;
  
        if (!order) return;
  
        var isCompleted = status === 'COMPLETED';
        // Check if order is paid - only show popup for paid orders
        var financialStatus = order.financial_status || '';
        var isPaid = financialStatus === 'paid' || financialStatus === 'authorized';
        // var isPaid = true;
  
        if (!isCompleted || !isPaid) {
          console.log("[Order Status Popup] Order not eligible - isCompleted:", isCompleted, "isPaid:", isPaid, "financial_status:", financialStatus);
          return;
        }
  
        var lineItems = order.line_items || [];
        var hasRelevantLineItem = lineItems.some(item => {
          // Check if the line item's variant_id is in our eligible variant IDs array
          return item.variant_id && ELIGIBLE_VARIANT_IDS.includes(item.variant_id);
        });

        if (!hasRelevantLineItem) {
          console.log("[Order Status Popup] No eligible variant found in order. Eligible variants:", ELIGIBLE_VARIANT_IDS);
          return;
        }
  
        console.log("[Order Status Popup] Conditions passed. Showing popup after short delay...");
          setTimeout(function () {
          buildPopup(order, tokenId);
          }, 1500);
      })
      .catch(err => console.error('[Order Status Popup] Failed to fetch token status:', err));
  });
  